export default {
      id: "ic_chevron-usage",
      viewBox: "0 0 15 15",
      url: "../dist/images/" + "sprite.svg#ic_chevron-usage",
      toString: function () {
        return this.url;
      }
    }